import { useRouter } from 'next/router';
import { useCallback } from 'react';

export type UpdateUrlQueryParams = { id?: string[]; usecase?: string };
export type DeleteUrlQueryParams = { usecase?: boolean };

type UpdateUrlFunctions = {
  updateUrl: (updateUrlQueryParams: UpdateUrlQueryParams) => void;
  removeFromUrl: (deleteUrlQueryParams: DeleteUrlQueryParams) => void;
};

export default function useUpdateUrl(): UpdateUrlFunctions {
  const { push, query, asPath } = useRouter();
  const getUseCase = useCallback(
    (usecase?: string) => {
      function getUseCaseFromUrl() {
        const urlQueryParams = asPath.split('?');
        const unparsedUseCaseFromUrl =
          urlQueryParams && urlQueryParams.length > 1
            ? urlQueryParams[1].split('&').find((urlParam) => urlParam.indexOf('usecase') !== -1)
            : '';

        const splittedUnparsedUrl = unparsedUseCaseFromUrl?.split('=');
        return splittedUnparsedUrl && splittedUnparsedUrl.length > 1 ? splittedUnparsedUrl[1] : '';
      }

      const jl = usecase || query.usecase || getUseCaseFromUrl();

      return jl;
    },
    [asPath, query.usecase]
  );

  const updateUrl = useCallback(
    ({ id, usecase }: UpdateUrlQueryParams) => {
      if (id === query.id && usecase === query.usecase) {
        return;
      }
      push(
        {
          pathname: `/hitch/[...id]`,
          query: {
            ...query,
            id: id || query.id,
            usecase: getUseCase(usecase),
          },
        },
        undefined,
        { shallow: true }
      );
    },
    [push, query, getUseCase]
  );

  const removeFromUrl = useCallback(
    ({ usecase }: DeleteUrlQueryParams) => {
      push(
        {
          pathname: `/hitch/[...id]`,
          query: {
            id: query.id,
            ...(usecase ? {} : { usecase: getUseCase() }),
          },
        },
        undefined,
        { shallow: true }
      );
    },
    [getUseCase, query.id, push]
  );
  return { updateUrl, removeFromUrl };
}
